import { render, staticRenderFns } from "./AnswerMachine.vue?vue&type=template&id=688af69c"
import script from "./AnswerMachine.vue?vue&type=script&lang=js"
export * from "./AnswerMachine.vue?vue&type=script&lang=js"
import style0 from "./AnswerMachine.vue?vue&type=style&index=0&id=688af69c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports